import React, { useState, useEffect } from 'react';
import { MemoryRouter, Route, Switch } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { StateMachineProvider, createStore } from 'little-state-machine';
import { Dialog } from '@reach/dialog';
import queryString from 'query-string';

import Modal from './components/Modal';
import ScrollToTop from './components/ScrollToTop';
import Art from './components/Art';
import Steps from './components/Steps';

import Data from './steps/01-data';
import Document from './steps/02-document';
import Folio from './steps/03-folio';
import Address from './steps/04-address';
import Delivery from './steps/05-delivery';
import Department from './steps/06-department';
import Pickup from './steps/07-pickup';
import Referred from './steps/08-referred';
import Summary from './steps/09-summary';
import Success from './steps/10-success';
import Files from './steps/11-files';
import Error from './steps/12-error';

import useStore from './store';

import { STORE_NAME } from './config';

// function log(store) {
//   console.log(store);
// }

// if (process.env.REACT_APP_ENV === 'production') {
createStore({ data: {} }, { name: STORE_NAME });
// } else {
//   createStore({ data: {} }, { name: STORE_NAME, middleWares: [log] });
// }

const App = props => {
  const [modal, setModal] = useState(false);
  const [{ selectedCard, selectedGroup }, setStore] = useStore();

  const handleInfoClick = () => {
    setModal(!modal);
  };

  const [stateTipo, setStateTipo] = useState(0);
  let tipo;
  let grupo;

  useEffect(() => {
    const parsed = queryString.parse(window.location.search);

    switch (parsed.tipo) {
      case 'internacional':
        setStateTipo(2);
        tipo = 2;
        break;
      case 'oro':
        setStateTipo(3);
        tipo = 3;
        break;
      case 'platinum':
        setStateTipo(4);
        tipo = 4;
        break;
      default:
        setStateTipo(0);
        tipo = 0;
        break;
    }

    switch (parsed.grupo) {
      case 'volar':
        grupo = 1;
        break;
      case 'latam':
        grupo = 2;
        break;
      case 'on':
        grupo = 3;
        break;
      case 'benefits':
        grupo = 4;
        break;
      default:
        grupo = 0;
        break;
    }

    setStore({
      selectedCard: parseInt(tipo),
      selectedGroup: parseInt(grupo),
      origen: parsed.origen || '',
    });
  }, [setStore]);

  if (!selectedCard || !selectedGroup) return null;

  return (
    <StateMachineProvider>
      <MemoryRouter
        initialEntries={[
          '/1',
          '/2',
          '/3',
          '/4',
          '/5',
          '/6',
          '/7',
          '/8',
          '/9',
          '/10',
          '/success',
          '/error',
        ]}
        initialIndex={0}
      >
        <ScrollToTop />

        <Steps onInfoClick={handleInfoClick} platinum={stateTipo === 4 ? true : false} />

        <Art />

        <div className="container">
          <Route
            render={({ location }) => (
              <AnimatePresence exitBeforeEnter initial={true}>
                <Switch location={location} key={location.pathname}>
                  {/* <Route exact path="/1" component={Success} /> */}
                  <Route exact path="/1" component={Data} />
                  <Route exact path="/2" component={Document} />
                  <Route
                    exact
                    path="/3"
                    render={() => <Folio platinum={stateTipo === 4 ? true : false} {...props} />}
                  />
                  <Route exact path="/4" component={Address} />
                  <Route exact path="/5" component={Delivery} />
                  <Route exact path="/6" component={Department} />
                  <Route exact path="/7" component={Pickup} />
                  <Route exact path="/8" component={Referred} />
                  <Route
                    exact
                    path="/9"
                    render={() => <Summary platinum={stateTipo === 4 ? true : false} {...props} />}
                  />
                  <Route exact path="/10" component={Files} />
                  <Route exact path="/success" component={Success} />
                  <Route exact path="/error" component={Error} />
                </Switch>
              </AnimatePresence>
            )}
          />
        </div>

        <Dialog isOpen={modal} onDismiss={() => setModal(false)} aria-label="Información adicional">
          <Modal onDismiss={() => setModal(false)} />
        </Dialog>

        <style jsx>{`
          div.container {
            flex: 1;
          }

          :global(#itau-tc) {
            min-height: 100vh;
          }
        `}</style>
      </MemoryRouter>
    </StateMachineProvider>
  );
};

export default App;
